import { get, patch, put } from '../../utils/http';

export const fetchSpecificTimeSheet = ({ accountId, timesheetId }) =>
  get(`/accounts/${accountId}/timesheets/${timesheetId}`);

export const fetchSpecificOSTimeSheet = ({ accountId, timesheetId }) =>
  get(`/accounts/${accountId}/timesheets/os/${timesheetId}`);

export const updateTimeSheet = ({ accountId, timesheetId, shouldWaitForBreaktimes, ...params }) =>
  patch(`/accounts/${accountId}/timesheets/${timesheetId}`, { ...params, options: { shouldWaitForBreaktimes } });

export const updateTimesheetTaskField = ({ accountId, timesheetId, fieldId, value }) =>
  patch(`/accounts/${accountId}/timesheets/${timesheetId}/timesheet-fields/${fieldId}`, { value });

export const approveAll = ({ accountId, ids }) => put(`/accounts/${accountId}/timesheets/approve`, { ids });

export const autoFillTimeSheet = ({ accountId, ids, override, shouldWaitForBreaktimes }) =>
  put(`/accounts/${accountId}/timesheets/autofill`, { ids, override, options: { shouldWaitForBreaktimes } });

export const autoFillTimeSheetBreaks = ({ accountId, breaktimes }) =>
  put(`/accounts/${accountId}/timesheets/autoFillBreaks`, {
    breaktimes
  });

export const fetchTimesheetPayrollFields = ({ accountId, branches, from, to, projectIds, employeeIds }) =>
  get(`/accounts/${accountId}/timesheets/payroll-fields`, { branches, from, to, projectIds, employeeIds });

export const updateTimesheetSlotPayrollField = ({ accountId, employeeSlotId, payrollFieldId, value }) =>
  patch(`/accounts/${accountId}/timesheets/payroll-fields/employees-slots/${employeeSlotId}/${payrollFieldId}`, {
    value
  });

export const updateTimesheetJobPayrollField = ({ accountId, jobId, payrollFieldId, value }) =>
  patch(`/accounts/${accountId}/timesheets/payroll-fields/jobs/${jobId}/${payrollFieldId}`, { value });
